module.exports = __webpack_public_path__ + "static/media/flag-sk.f053d876.webp";